var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"appLayout"}},[_c('app-drawer',{staticClass:"app--drawer"}),_c('app-toolbar',{staticClass:"app--toolbar"}),_c('v-content',[_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }